export default function checkoutCart({ main, on, elm, state, publish }) {
	main(_ => {
		elm.update = update;
	});

	const update = async function () {
		const {language} = state.get();
		const action = `index.php?route=extension/evasota/checkout/checkout_cart.info&language=${language}`;

		const loader = document.createElement('div');
		loader.classList.add('lmask');
		elm.insertAdjacentElement('afterbegin', loader);

		try {
			const response = await fetch(action, {
				method: 'GET',
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			});

			if (!response.ok) {
				throw new Error(`Cart load failed: ${response.status}`);
			}

			const result = await response.json();
			elm.innerHTML = result.cart;
			publish('cart-counter', result.counter);
		} catch (e) {
			alert(`Error fetching cart info: ${e}`);
		} finally {
			loader?.remove();
		}
	};
};

export const model = {};
